<template>
  <md-card class="md-card-chart" :style='{ height: `${height}px` }'>
    <md-card-header class='md-card-header-text'>
      <div class="ct-chart">
        <h4 class="title"><strong>{{ preTitle }}</strong> {{ title }}</h4>
      </div>
    </md-card-header>
    <md-card-content style="height: 100%; background-color: #DADADA; border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
      <div style='color: #2c2c2c60; font-size: 20px; font-weight: 500; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'>
        {{ error ? this.$t('cardNoData.errorLoadingGraph') : this.$t('cardNoData.notEnoughData') }}
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    preTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    height: {
      required: true
    },
    error: {
      default: false
    }
  }
}
</script>

<style>

</style>
